import { render, staticRenderFns } from "./StdizerChemical.vue?vue&type=template&id=6a081384&scoped=true"
import script from "./StdizerChemical.vue?vue&type=script&lang=js"
export * from "./StdizerChemical.vue?vue&type=script&lang=js"
import style0 from "./StdizerChemical.vue?vue&type=style&index=0&id=6a081384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a081384",
  null
  
)

export default component.exports